import cookie from "js-cookie";

import {
  BP_REFRESH_TOKEN_COOKIE,
  BP_TOKEN_COOKIE,
  EXPERIENCE_ID_COOKIE,
  LONG_TERM_STORAGE_KEY,
  TEST_IDENTITY_ID_COOKIE,
  USER_SEGMENT_COOKIE
} from "./cookieNames";

export const isLoggedOutMember = () => {
  return isMemberFromFingerprint() && !isMemberFromUserSegment();
};

export const userHasExpiredAuthTokensInSSR = (
  cookies: Partial<{
    [key: string]: string;
  }>
) => {
  const refreshToken = cookies[BP_REFRESH_TOKEN_COOKIE];
  const bpToken = cookies[BP_TOKEN_COOKIE];

  return !refreshToken && !bpToken;
};

const isMemberFromUserSegment = (): boolean => {
  return cookie.get(USER_SEGMENT_COOKIE) === "member";
};

export const isMemberFromFingerprint = () => {
  const { userType } = JSON.parse(cookie.get(LONG_TERM_STORAGE_KEY) || "{}");
  return userType === "member";
};

export const getExperienceId = (): string | undefined => {
  if (typeof window === "undefined") return;
  return cookie.get(EXPERIENCE_ID_COOKIE);
};

export const getTestIdentity = (): string => {
  let testIdentity = cookie.get(TEST_IDENTITY_ID_COOKIE);

  if (!testIdentity) {
    testIdentity = "test";
    cookie.set(TEST_IDENTITY_ID_COOKIE, testIdentity);
  }

  return testIdentity;
};
